import { EnrollApi } from 'api';
import { useAuthMutation } from 'queries/query';

/**
 * 랜덤 추첨.
 * 저장이 아니라 후보를 뽑아 오기만 하므로 캐시를 건드리지 않는다.
 * 매번 결과가 달라야 해서 쿼리가 아닌 뮤테이션으로 둔다.
 */
function useDrawRandom() {
  return useAuthMutation(EnrollApi.drawRandom);
}

export default useDrawRandom;
